@import '~style-sheet-helpers/core.less';
@import '../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../constants/spacing.module.less';

@fontSize: 14px;

.modal-body {
  padding: 10px 20px;
}

.label-wrap {
  display: grid;
  grid-template-columns: 150px 300px;
  padding: 10px 0;
  > div:first-child {
    text-align: right;
    padding-right: 10px;
    font-weight: 500;
  }
  > div:last-child {
    color: @product-page--inventory-modal-label--text-color;
  }
}

.items-header,
.items-header-extended {
  margin-top: 10px;
  background-color: var(--grey-200);
  font-weight: 500;
  border: 1px solid var(--grey-300);
}

.items-header-extended,
.items-body-extended {
  font-size: @fontSize;
  display: grid;
  grid-template-columns: 70px 90px 110px 1fr 110px 150px 1fr 110px;
  .item-cell {
    padding: @space-8 @space-16;
    .truncate();
  }
}

.items-header,
.items-body {
  font-size: @fontSize;
  display: grid;
  grid-template-columns: 70px 90px 110px 150px 1fr 110px;
  > div {
    padding: @space-8 @space-16;
    .truncate();
  }
}

.items-body,
.items-body-extended,
.no-records-or-loading {
  border-bottom: 1px solid var(--grey-300);
  border-left: 1px solid var(--grey-300);
  border-right: 1px solid var(--grey-300);
}

.no-records-or-loading {
  text-align: center;
  font-style: italic;
  padding: 5px;
  font-size: @fontSize;
}

.loading {
  border-top: 0;
  height: 26px;
  width: 26px;
  grid-template-columns: 100%;
}

.loading-icon {
  width: 28px;
  height: 28px;
  margin: auto;
}

.history-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: @space-16;
}

.text {
  height: 24px;
}

.items-body,
.items-body-extended {
  .item-cell {
    overflow: hidden;
    overflow-wrap: break-word;
    white-space: normal;
  }
}
